import { Gamecloud } from '../../gamecloud';
import { LogsUI, createLogsInstances } from './logsUI';
import Axios from '../../../../../../../../node_modules/axios';

class Logs extends Gamecloud {

  private logfile;

  public constructor(private ui: LogsUI) {
    super();

    if (typeof this.ui.getFiles() !== 'undefined' && this.ui.getFiles() && this.ui.getFiles().file_1 && typeof this.ui.getFiles().file_1 !== 'undefined') {
      this.logfile = this.ui.getFiles().file_1;
    }

    this.loader.enable();
    this.getLogs();
    this.ui.renderSelectbox(this.ui.getFiles(), this.afterRenderSelect.bind(this));

    window.setInterval(() => {
      this.getLogs();
    }, 10000);
  }

  private afterRenderSelect() {
    this.ui.onChangeFile(this.setLogFile.bind(this));
  }

  private setLogFile(value) {
    this.logfile = value;
  }

  private getLogs() {
    const bodyFormData = new FormData();
    bodyFormData.append('load', 'true');
    bodyFormData.append('ExtConfig[config]', this.logfile);
    Axios.post(window.location.href, bodyFormData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then((response) => {
      this.loader.disable();
      this.ui.update(response.data.ExtConfig.content);
    })
  }
}

export function initLogs() {
  const instances = createLogsInstances();
  return instances.map((ui: LogsUI) => {
    return new Logs(ui);
  })
}
